import ProductComparisonBrand from '@src/quince-site-common/src/domains/ProductComparisonBrand'
import { PPS_PC_ADDITONAL_ATTRIBUTE_NAME } from '@src/quince-site-common/src/utils/constants'
import { formatDateToMMMM_YYYY, getLocalDateFromUTCDate } from '@src/quince-site-common/src/utils/dateUtils'

export const getTooltipContent = (productComparisionsBrands: ProductComparisonBrand[]) => {
  let maxDate = 0
  if (productComparisionsBrands.length > 0) {
    productComparisionsBrands.forEach(pcb => {
      const updatedAt = pcb.prices[0].updatedAt
      if (updatedAt) {
        const variantUpdatedAtDate = new Date(updatedAt).getTime()
        if (maxDate < variantUpdatedAtDate) {
          maxDate = variantUpdatedAtDate
        }
      }
    })
    if (maxDate > 0) {
      const utcDate = new Date(maxDate) // Converting into date object
      // Now using utcdate object converting it into local time from UTC
      const localDate = getLocalDateFromUTCDate(utcDate)
      const formatedDate = formatDateToMMMM_YYYY(localDate)
      return `Competitor information gathered in ${formatedDate}; pricing is subject to change.`
    } else return ''
  }
  return ''
}

export const getBrandsExtraPrice = (data, name) => {
  return typeof data?.additionalProperties?.find(item => item.name == name)?.value === 'number'
    ? data.additionalProperties.find(item => item.name == name).value
    : 0
}

export const getBrandPricePerServing = (data: ProductComparisonBrand) => {
  const brandPrice = data?.additionalProperties?.find(item => item.name === PPS_PC_ADDITONAL_ATTRIBUTE_NAME)
  return Number(brandPrice?.value)
}
export const getVitaminSavingsPercentage = (data: ProductComparisonBrand, quincePPS?: number) => {
  const brandPrice = getBrandPricePerServing(data)
  if (!brandPrice || !quincePPS) return 0
  return Math.round(((brandPrice - quincePPS) * 100) / brandPrice)
}
